import vue from "vue";

export default {
    SET_TITLE: (state, title) => {
        state.title = title;
    },
    SET_TITLE_EN: (state, titleEn) => {
        state.titleEn = titleEn;
    },
    SET_KEY: (state, key) => {
        state.key = key;
    },
    SET_PERMISSION_ROOMS: (state, permissionRooms) => {
        state.permissionRooms = permissionRooms;
    },
    SET_PERMISSION_ROOM: (state, permissionRoom) => {
        state.permissionRoom = permissionRoom;
    },
    SET_STATUS: (state, status) => {
        state.status = status;
    },
    SET_PERMISSION_ROOMS_TO_EDIT: (state, permissionRoomsToEdit) => {
        state.permissionRoomsToEdit = permissionRoomsToEdit;
    },
    SET_TOTAL: (state, total) =>{
        state.total = total
    },
}